import { useMemo } from 'react'
import { Box } from '@mantine/core'

import type { TransactionsProps } from '@/modules/budget/components/Transactions/Transactions.types'

import { Loader } from '@/components/Loader/Loader'
import { Title } from '@/components/Title/Title'
import { TransactionsList } from '@/components/TransactionsList/TransactionsList'

import {
  useTransactionServiceTransactionControllerGetTransactions,
  UseTransactionServiceTransactionControllerGetTransactionsKeyFn,
} from '@/__generated__/queries'
import type { TransactionControllerGetTransactionsResponse } from '@/__generated__/requests/types.gen'

import classes from './Transactions.module.css'

export function Transactions({ endDate, startDate, type }: TransactionsProps) {
  const { data, isFetching, isLoading } =
    useTransactionServiceTransactionControllerGetTransactions(
      {
        endDate,
        startDate,
        type,
      },
      UseTransactionServiceTransactionControllerGetTransactionsKeyFn({
        endDate,
        startDate,
        type,
      }),
      {
        staleTime: 1000 * 60 * 60,
      },
    )

  const transactions =
    useMemo<TransactionControllerGetTransactionsResponse | null>(() => {
      if (!data) {
        return null
      }

      return data
    }, [data])

  return (
    <Box className={classes.container}>
      <Title variant="h1">Transactions</Title>

      {isFetching || isLoading ? (
        <Box h={110}>
          <Loader isMinimized />
        </Box>
      ) : (
        <TransactionsList transactions={transactions} type={type} />
      )}
    </Box>
  )
}
